const Required = () => {
  return <span className="text-utility-violet-600">*</span>;
};

export default Required;
